export default __webpack_public_path__ + "static/media/25.907479e7.jpg";